import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navigation from './components/Navigation';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import { fetchOctoberCMSData } from './data/octobercms-data';
import './App.css';

function App() {
  const [siteData, setSiteData] = useState(null);

  useEffect(() => {
    const loadSiteData = async () => {
      try {
        const data = await fetchOctoberCMSData();
        setSiteData(data);
      } catch (error) {
        console.error('Site verileri yüklenirken hata:', error);
      }
    };

    loadSiteData();
  }, []);

  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <Navigation siteData={siteData} />
          <Routes>
            <Route path="/" element={<Home siteData={siteData} />} />
            <Route path="/about" element={<About siteData={siteData} />} />
            <Route path="/contact" element={<Contact siteData={siteData} />} />
          </Routes>
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
